import { axiosInsight } from '../axiosInstance';

export interface BinCleanUpReportPayload {
	city: string;
	to: string;
	from: number;
}

// 🔹 Bin Cleanup Report API
export const binCleanUpReportApi = async (city: any, to: any, from: any) => {
	const res = await axiosInsight.get(
		`/insights/binCleanUpReport?city=${city}&to=${to}&from=${from}`,
	);
	return res.data;
};

// 🔹 Ward-wise TSP Details API
export const tspWardDetailsApi = async (wardNumber: number, city: string, date: string) => {
	const res = await axiosInsight.get(
		`/insights/tsp-wardwisedetail?wardNumber=${wardNumber}&city=${city}&date=${date}`,
	);
	return res.data;
};

const tspApi = {
	binCleanUpReportApi,
	tspWardDetailsApi,
};

export default tspApi;
